'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import ym, { YMInitializer } from 'react-yandex-metrika';

const isProduction = process.env.NODE_ENV === 'production';
const YM_COUNTER_ID = process.env.NEXT_PUBLIC_YANDEX_METRIKA_ID;

const YandexMetrika = () => {
    const pathname = usePathname();

    useEffect(() => {
        if (pathname && YM_COUNTER_ID && isProduction) {
            ym('hit', pathname);
        }
    }, [pathname]);

    if (!YM_COUNTER_ID || !isProduction) {
        return null;
    }

    return (
        <YMInitializer
            accounts={[Number(YM_COUNTER_ID)]}
            options={{
                defer: true,
                webvisor: true,
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                trackHash: true,
            }}
            version="2"
        />
    );
};

export default YandexMetrika;
